import { EAuditAction } from '../constants/auditActions';

/**
 * Returns Tailwind classes for the action badge based on the action type.
 * - Green: Create/add actions (创建新群组, 添加新管理员)
 * - Red: Delete/remove/ban destructive actions (删除违规群聊, 删除无效反馈)
 * - Blue: Update/modify/process actions (修改用户状态, 处理举报)
 */
export const getActionStyle = (action: string): string => {
  const destructiveActions: string[] = [
    EAuditAction.BAN_USER,
    EAuditAction.DELETE_USER,
    EAuditAction.DISABLE_SPACE_OWNER,
    EAuditAction.DEACTIVATE_SPACE,
    EAuditAction.REMOVE_SPACE_MEMBER,
    EAuditAction.DELETE_ROOM,
    EAuditAction.REMOVE_ROOM_MEMBER,
    EAuditAction.DELETE_MESSAGE,
    EAuditAction.REMOVE_SENSITIVE_WORD,
    EAuditAction.DELETE_CATEGORY,
    EAuditAction.DELETE_BOT,
    EAuditAction.DISABLE_BOT,
    EAuditAction.REVOKE_BOT_TOKEN,
    EAuditAction.UNINSTALL_BOT,
    EAuditAction.BOT_WEBHOOK_AUTO_DISABLED,
  ];

  const createActions: string[] = [
    EAuditAction.CREATE_USER,
    EAuditAction.CREATE_SPACE_OWNER,
    EAuditAction.CREATE_SPACE,
    EAuditAction.CREATE_ROOM,
    EAuditAction.ADD_SPACE_MEMBERS,
    EAuditAction.ADD_ROOM_MEMBERS,
    EAuditAction.ADD_SENSITIVE_WORD,
    EAuditAction.BATCH_UPLOAD_SENSITIVE_WORDS,
    EAuditAction.BACKOFFICE_ADMIN_CREATED,
    EAuditAction.CREATE_CATEGORY,
    EAuditAction.GENERATE_INVITATION_CODES,
    EAuditAction.GENERATE_SPACE_INVITATION_LINK,
    EAuditAction.ENABLE_SPACE_OWNER,
    EAuditAction.ACTIVATE_SPACE,
    EAuditAction.UNBAN_USER,
    EAuditAction.UNMUTE_USER,
    EAuditAction.CREATE_BOT,
    EAuditAction.ENABLE_BOT,
    EAuditAction.ISSUE_BOT_TOKEN,
    EAuditAction.INSTALL_BOT,
  ];

  if (destructiveActions.includes(action)) return 'bg-red-100 text-red-800';
  if (createActions.includes(action)) return 'bg-green-100 text-green-800';

  return 'bg-blue-100 text-blue-800';
};
